import { extend } from 'flarum/common/extend';
import { passwordless } from '../utils/magicLink';
export default function extendSettingsPage() {
  // SettingsPage é carregada sob demanda no 2.x.
  extend('flarum/forum/components/SettingsPage', 'accountItems', function (items) {
    if (passwordless()) items.remove('changePassword');
  });

  // O Canela repete o "Alterar senha" na aba Segurança.
  extend('flarum/forum/components/UserSecurityPage', 'settingsItems', function (items) {
    if (passwordless()) items.remove('canelaPassword');
  });
}
flarum.reg.add('ramon-magic-link', 'forum/extenders/extendSettingsPage', extendSettingsPage);